import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import MultiSelectDropdown from "../../../Component/BasicComponents/Dropdowns/MultiSelectDropdown";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useStateListData } from "../../Onboarding/hooks/useOnBoard";
import { useGetOrgUnitsData } from "../../Employee/hooks/useEmployee";
import { useAddBrandCompetitor, useGetSingleBrandCompetitor, useUpdateBrandCompetitor } from "../hooks/useProductCatalogue";
import { Spinner } from "reactstrap";

interface ProductListByBrandModalContentProps {
  selectedBrand: any;
  selectedNames: { id: number; name: string }[];
  setSelectedNames: React.Dispatch<
    React.SetStateAction<{ id: number; name: string }[]>
  >;
  mode: "add" | "edit";
 
  handleClose: () => void;
  productID:any;
  ProductData:any;
}

const ProductListByBrandModalContent: React.FC<
  ProductListByBrandModalContentProps
> = ({
  selectedBrand, 
  handleClose,
  productID,
  ProductData,
  mode
}) => {
  const [competitorName,setCompetitorName]=useState()
  const [brandName,setBrandName]=useState(ProductData.brand||"")
  const [isSubmitting, setIsSubmitting] = useState(false);
const [modalReady, setModalReady] = useState(false);
  const [drate,setDrate]=useState()
  const [states, setStates] = useState<any[]>([])
  console.log('selectedBrand',productID)

  const {data:getSingleBrandCompetitor}=useGetSingleBrandCompetitor({
    enabled:!!selectedBrand.CompetitorId,
    id:selectedBrand.CompetitorId
  })


   useEffect(() => {
   if (mode === "edit" && getSingleBrandCompetitor?.data) {
    const data = getSingleBrandCompetitor.data;

    setBrandName(data?.BrandName || "");
    setCompetitorName(data?.CompetitorName || "");
    setDrate(data?.Drate || "");

    const stateids = data?.Istateids.split(",").map((tag: string) => tag.trim()) || [];
    setStates(stateids);

    setModalReady(true); // ✅ modal data loaded
  } else if (mode === "add") {
    setModalReady(true); // ✅ add mode, no data needed
  }
  }, [getSingleBrandCompetitor, mode]);

  // const {data:orgUnitsList}=useGetOrgUnitsData({
  //   enable:true
  // })
  // console.log('org',orgUnitsList?.data)

const {data:StateList}=useStateListData({
  enable:true
})

const formateStateListData=Object.entries(StateList?.data?.data||[]).map((item:any)=>({
id:item[0],
label:item[1],
})
)

const {mutate:addCompetitor}=useAddBrandCompetitor()
const {mutate:updateCompetitor}=useUpdateBrandCompetitor()
// const handleSubmit=(e:React.FormEvent)=>{
//   e.preventDefault();
//     if (isSubmitting) return;
//  const payload:any = {
//     CompetitorName: competitorName,
//     Drate: drate,
//     Istateid: Array.isArray(states) ? states.map((t: any) => t.label || t) : [],
//     ProductId: productID || "",

//   };
//   console.log('payload',payload)
//   if (mode === "edit") {
//     updateCompetitor(
//       { reqBody: payload, id: selectedBrand.CompetitorId},
//       {
//         onSuccess: () => {
//           handleClose();
//         },
//         onError: (err) => {
//           console.error(err);
//         },
//       }
//     );
//   } else {
//     addCompetitor(payload, {
//       onSuccess: () => {
//         handleClose();
//       },
//       onError: (err) => {
//         console.error(err);
//       },
//     });
//   }
// }

const handleSubmit = (e: React.FormEvent) => {
  e.preventDefault();

  if (isSubmitting) return; // ⛔ Prevent multiple clicks

  const payload: any = {
    CompetitorName: competitorName,
    Drate: drate,
    Istateid: Array.isArray(states) ? states.map((t: any) => t.label || t) : [],
    ProductId: productID || "",
  };

  setIsSubmitting(true); // ⏳ start submitting

  const onSettled = () => {
    setIsSubmitting(false); // 🔄 reset after request
    handleClose();
  };

  if (mode === "edit") {
    updateCompetitor(
      { reqBody: payload, id: selectedBrand.CompetitorId },
      {
        onSuccess: onSettled,
        onError: (err) => { console.error(err); setIsSubmitting(false); },
        onSettled,
      }
    );
  } else {
    addCompetitor(payload, {
      onSuccess: onSettled,
      onError: (err) => { console.error(err); setIsSubmitting(false); },
      onSettled,
    });
  }
};


  return (
    <>
    {
    !modalReady && StateList?(
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ):(
    <form onSubmit={handleSubmit}>
      {/* Competitor Name */}
      <div className="col mb">
  
        <div className="col-md">
          <label style={{ fontWeight: "500" }}>Competitor Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter competitor name"
            value={competitorName || ""}
            onChange={(e:any) =>
              setCompetitorName(
                e.target.value,
              )
            }
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
        <div className="col-md">
          <label className="mt-2" style={{ fontWeight: "500" }}>
            Brand Name
          </label>
          <input
            type="test"
            className="form-control"
            value={brandName || ""}
            onChange={(e:any) =>
              setBrandName(e.target.value,
              )
            }
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>

        <div className="col-md">
          <label className="mt-2" style={{ fontWeight: "500" }}>
            Drate
          </label>
          <input
            type="test"
            className="form-control"
            value={drate || ""}
            onChange={(e:any) =>
              setDrate(
                e.target.value,
              )
            }
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>

        <div className="col-md">
          {/* Multi-Select Dropdown */}
          <div className="d-flex flex-column">
            <label className="mt-2 fw-medium">States</label>
            <label
              style={{
                fontStyle: "italic",
                color: "lightgrey",
                fontWeight: 300,
                fontSize: 12,
                marginTop: -7,
              }}
            >
              Select states for the chosen holiday
            </label>
          </div>
          <RouteDropdown
          isMulti={true}
          onChange={(value: any) =>
            setStates( value,
            )
          }
          options={formateStateListData||[]}
          value={states}
         
          />
        
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-start mt-3 gap-2">
         <Btn
  style={{ backgroundColor: "#43B9B2", color: "white" }}
  type="submit"
  disabled={isSubmitting} // ✅ Disable while submitting
>
  {isSubmitting ? "Submitting..." : mode !== "add" ? "Update Brand" : "Submit"}
</Btn>
          <Btn
            style={{
              backgroundColor: "#F9FAFC",
              color: "#000",
              border: "1px solid #E0E0E0",
            }}
            type="button"
            onClick={()=>handleClose()}
          >
            Cancel
          </Btn>
        </div>
      </div>
    </form>
      )
    }
    </>
  );
};

export default ProductListByBrandModalContent;
